import { useState, useMemo } from "react";
import { useHandler } from "./use-handler.es.js";
function useControlledState(value, onChange) {
  const [state, setState] = useState(value);
  const handleChange = useHandler(onChange || setState);
  const returnValue = onChange ? value : state;
  return useMemo(
    () => [returnValue, handleChange],
    [handleChange, returnValue]
  );
}
export {
  useControlledState
};
